<template>
  <div>
    <div class="list-group">
      <div class="list-group-item" v-for="condition in conditions">
        <div class="row row--tight">
          <div class="col-md-5">
            <label :for="`${condition.id}-type`">Conditie type</label>
            <select
              class="custom-select"
              :id="`${condition.id}-type`"
              v-model="condition.type"
            >
              <option v-for="(typeLabel, typeKey) in conditionTypes" :value="typeKey" :key="typeKey">
                {{ typeLabel }}
              </option>
            </select>
          </div>

          <div class="col-md-5">
            <div v-if="condition.type !== 'all_pages'">
              <label :for="`${condition.id}-value`">Conditie waarde</label>
              <input
                class="form-control"
                type="text"
                :id="`${condition.id}-value`"
                v-model="condition.value"
              >
            </div>
          </div>

          <div class="col-md-2 mt-2 mt-md-0 align-items-end d-flex">
            <button class="btn btn-outline-danger w-100" type="button" @click="() => onConditionRemove(condition)">
              <i class="fas fa-times" aria-hidden="true"></i>
              Verwijder
            </button>
          </div>
        </div>
      </div>
    </div>

    <input type="hidden" name="conditions" :value="JSON.stringify(conditions)">

    <button class="btn btn-primary mt-2" type="button" @click="onConditionAdd">
      <i class="fas fa-plus" aria-hidden="true"></i>
      Conditie toevoegen
    </button>
  </div>
</template>

<script>
  export default {
    props: ['props'],

    data() {
      return {
        conditions: JSON.parse(this.props.conditions),
        conditionTypes: {
          'all_pages': 'Alle pagina\'s',
          'specific_page': 'Specifieke pagina',
        },
      };
    },

    methods: {
      onConditionRemove(condition) {
        const indexOfCondition = this.conditions.map(condition => condition.id).indexOf(condition.id);

        if (indexOfCondition >= 0) {
          const conditions = Array.prototype.slice.call(this.conditions);
          conditions.splice(indexOfCondition, 1);
          this.conditions = conditions;
        }
      },

      onConditionAdd() {
        this.conditions.push({
          id: Math.round(Math.random() * 9999999),
          type: 'all_pages',
          value: '',
          operator: 'and',
        });
      },
    },
  };
</script>
